import { App } from "@app/App";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "@app/config/i18n";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
